import { render, staticRenderFns } from "./second-index.vue?vue&type=template&id=0a88792d&scoped=true"
import script from "./second-index.vue?vue&type=script&lang=js"
export * from "./second-index.vue?vue&type=script&lang=js"
import style0 from "./second-index.vue?vue&type=style&index=0&id=0a88792d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a88792d",
  null
  
)

export default component.exports